// extracted by mini-css-extract-plugin
export var link = "_tp-0";